import { Skeleton } from './ui/skeleton';

export function BookmarkCardSkeleton() {
  return (
    <article className="flex h-[130px] overflow-hidden rounded-lg border border-border bg-card">
      <div className="flex flex-1 items-start gap-2.5 p-3">
        {/* Favicon */}
        <Skeleton className="mt-0.5 h-4 w-4 flex-shrink-0 rounded-sm" />

        <div className="min-w-0 flex-1 space-y-2">
          {/* Title */}
          <Skeleton className="h-4 w-3/4" />

          {/* Domain */}
          <Skeleton className="h-3 w-1/3" />

          {/* Description */}
          <div className="space-y-1.5 pt-1">
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-3 w-2/3" />
          </div>

          {/* Tags */}
          <div className="flex gap-1 pt-1">
            <Skeleton className="h-5 w-12 rounded-full" />
            <Skeleton className="h-5 w-16 rounded-full" />
          </div>
        </div>
      </div>

      {/* Thumbnail placeholder (shown randomly) */}
      <Skeleton className="h-[130px] w-[130px] flex-shrink-0 rounded-none" />
    </article>
  );
}
